






























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import UiHexagon from '@/components/UiHexagon.vue';
import UiWindow from '@/components/UiWindow.vue';
@Component({components: {UiWindow, UiHexagon}})
export default class UiLevelStart extends Vue {

  @Prop() public visible!: boolean;
  @Prop() public level!: number;
  @Prop() public numberOfBombs!: number;

  private isVisible: boolean = false;

  @Watch('visible') private onVisibleChanged(): void {
    this.isVisible = this.visible;
  }

  @Watch('isVisible') private onIsVisibleChanged(): void {
    this.$emit('update:visible', this.isVisible);
  }
}
